// extracted by css-extract-rspack-plugin
export default {"core-exclusive":"n8oemo","coreExclusive":"n8oemo","cta":"OxTSDn"};